// extracted by mini-css-extract-plugin
module.exports = {"title":"removeCustomPageModal_title__2RDX8","description":"removeCustomPageModal_description__2mer9"};